/** Joins truthy class names: cx(a, cond && b) */
export function cx(...names) {
  return names.filter(Boolean).join(' ')
}
